//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'dfd',
  components: {},
  props: {
    tabsName: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      activities: [{
        content: '支持自定义颜色',
        timestamp: '2018-04-03 20:46',
        color: '#f90',
        type: 'quit'
      }, {
        content: '支持自定义尺寸',
        timestamp: '2018-04-03 20:46',
        size: 'large',
        color: '#0bbd87',
        type: 'post_transfer'
      }, {
        content: '默认样式的节点',
        timestamp: '2018-04-03 20:46'
      }]
    };
  },
  methods: {
    // 删除调薪记录
    deleteRecord: function deleteRecord(id) {
      this.$emit('deleteSalaryList', id);
    },
    // 编辑调薪记录
    editRecord: function editRecord(val) {
      this.$emit('getSalaryContent', val);
    }
  }
};